module.exports = __webpack_public_path__ + "img/hilton_qr_menu.c1056fd4.png";